export default "__VITE_ASSET__CIsowoT7__"